import { Component, OnInit, OnChanges, Input, Output, ElementRef, ViewChild, NgZone, EventEmitter } from '@angular/core';
// import { MapsAPILoader } from '@agm/core';
import { google } from "google-maps";

declare var google: any;

@Component({
  selector: 'app-location-places-lookup',
  templateUrl: './location-places-lookup.component.html',
  styleUrls: ['./location-places-lookup.component.scss']
})
export class LocationPlacesLookupComponent implements OnInit, OnChanges {

  public _locationValid: Boolean = false;
  private _autocomplete;

  public locationModel;
  public showLocationError: Boolean = false;
  public formattedAddress: string = null;

  @ViewChild('locationElement') ele: ElementRef;

  @Input()
  placeholder;

  @Input()
  enableError;

  @Input()
  selectedAddressLine;

  @Output()
  locationSet: EventEmitter<any> = new EventEmitter();

  @Output()
  locationRemoved: EventEmitter<any> = new EventEmitter();

  constructor(
    // private _mapsAPILoader: MapsAPILoader,
    private _ngZone: NgZone
  ) { }

  ngOnInit() {

    // this._mapsAPILoader.load().then(() => {

    //   this._autocomplete = new google.maps.places.Autocomplete(
    //     this.ele.nativeElement, {
    //       componentRestrictions: {country: 'uk'}
    //     }
    //   );

    //   this._autocomplete.addListener('place_changed', () => {

    //     this._ngZone.run(() => {

    //        // Get the place details from the autocomplete object.
    //       const place: google.maps.places.PlaceResult = this._autocomplete.getPlace();

    //       if (typeof place.place_id === 'undefined') {
    //         // return error...
    //         this._locationValid = false;
    //         return;
    //       }

    //       this._locationValid = true;
    //       this.showLocationError = false;

    //       // send place obj back to parent
    //       this.locationSet.emit(place);
    //     });

    //   });
    // });

  }

  ngOnChanges(changes: any) {
    this.formattedAddress = '';

    if (typeof changes.selectedAddressLine === 'undefined') {
      return;
    }

    this._ngZone.run(() => {
      if (changes.selectedAddressLine.currentValue !== changes.selectedAddressLine.previousValue) {
        this.formattedAddress = '';
        this.formattedAddress = changes.selectedAddressLine.currentValue;
      }
    });
  }

  checkLocationInput(value) {

    if (value === '') {
      this.locationRemoved.emit(true);
    }

    if (!this._locationValid && value !== '') {
      this.showLocationError = true;
    } else {
      this.showLocationError = false;
    }
  }

}
